<div class="title-grid">
    <img class="title-icon" [src]="'/assets/images/distribution-groups.svg'" />
    <h2 translate>grid.navs.distributionGroups</h2>
</div>
<que-distribution-group-list></que-distribution-group-list>